import React from 'react'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-spinner'


import { pageHelpers } from ".."
import { disableJDOpsCenterIntegrationForTeam, loadExternalTeams, getIntegrationForTeam, environment } from "../../../api"
import { AdminLinkBubble, } from '../../ui'

import '../../../stylesheets/Teams.css'

class ExternalOrgConnectionPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        pageHelpers.setupSingleRunAnimationEvents()
        const { token } = props

        let teamID = this.urlParams.team_id
        if (this.user && !teamID) {
            teamID = this.user.activeTeam
        }

        this.state = {
            loading: false,
            errors: [],
            teamID,
            organizations: [],
            token,
            integration: null,
            integrationID: null,
            externalTeams: [],
            selectedExternalTeam: null,
        }
        this.connectOrganization = this.connectOrganization.bind(this);
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)
    }

    async componentDidMount() {
        let { token, teamID } = this.state;
        const integration = await getIntegrationForTeam(teamID, token);
        this.setState({
            integration: integration,
            integrationID: integration.id,
            loading: true
        });
        if (integration.has_access_token) {
            this.setState({ externalTeams: await loadExternalTeams(integration.id, token) })
        }
        let { externalTeams } = this.state
        const selectedExternalTeam = externalTeams.find(team => team.id === integration.selected_external_team);
        console.log(selectedExternalTeam);
        await this.connectOrganization(selectedExternalTeam)
        this.setState({ loading: false });
    }

    async connectOrganization(selectedOrganization) {
        let { teamID, token, integrationID } = this.state;
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', `Bearer ${token.accessToken}`);
        if (selectedOrganization.connected) {
            // Update the selected_external_team in the integration and set connected to true in the external_team
            try {
                let endpoint = `${environment.API_URL}/integrations/jdo/${integrationID}/create_external_assets/`;
                let response = await fetch(endpoint, {
                    method: 'PATCH',
                    headers: headers,
                    body: JSON.stringify({ selected_external_team: selectedOrganization.id })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                // If a response from the server is received, handle the next step
                if (response.status === 204) {
                    window.location.href = "/team?tab=3";
                } else {
                    console.error("Unexpected response received from the server.");
                }
            } catch (error) {
                console.error("A fetch error occurred: ", error);
                await disableJDOpsCenterIntegrationForTeam(teamID, token);
                window.location.href = "/team?tab=3&integration_error=true";
            }
        } else {
            // Delete Integration and redirect to beginning of flow
            console.error("Selected Organization isn't authorized in John Deere Ops Center");
            await disableJDOpsCenterIntegrationForTeam(teamID, token);
            window.location.href = "/team?tab=3&error=Selected Organization isn't authorized in John Deere Ops Center";
        }
    }


    render() {
        let {
            errors, teamID, loading,
        } = this.state

        return (loading ? <Loader type="TailSpin" color="orange" width={60} height={60} /> :
            <div className="m-0 p-0">
                {teamID && this.user && this.user.isSupport ?
                    <AdminLinkBubble url={`marksman_api/team/${teamID}`}
                        modelName="Team"
                        className="mt-2" /> :
                    null}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
            </div>
        )
    }
}

export default withRouter(ExternalOrgConnectionPage)


// WEBPACK FOOTER //
// ./src/components/pages/teams/ExternalOrgConnectionPage.js